import {browserHistory} from 'react-router';
import {applyMiddleware, createStore} from 'redux';
import thunk from 'redux-thunk';
import {routerMiddleware} from 'react-router-redux';
import rootReducer from '../rootReducer';

const reactRouterReduxMiddleware = routerMiddleware(browserHistory);

const store = createStore(
  rootReducer,
  applyMiddleware(
    thunk,
    reactRouterReduxMiddleware
  )
);

export default store;



// WEBPACK FOOTER //
// ./src/store/store.prod.js